import EventBus from 'eventbusjs'

var _EventBus=EventBus

if(!window.frameElement){
    window.__e_EventBus__=EventBus
    _EventBus=EventBus
}

if(window.frameElement&&window.parent&&window.parent.__e_EventBus__){
    _EventBus=window.parent.__e_EventBus__
}

export default _EventBus